import type { ErrorLike } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { graphql, readFragment } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

const FeedDetails_Feed = graphql(/* GraphQL */ `
  fragment FeedDetails_Feed on Feed {
    id
    name
    lastRefreshed
    collection {
      id
    }
    connectionMetadata {
      ... on RSSFeedConnectionMetadata {
        __typename
        url
      }
      ... on NewsSearchConnectionMetadata {
        __typename
        query
      }
    }
  }
`)

export const GetFeedDetails = graphql(
  /* GraphQL */ `
    query GetFeedDetails($input: FeedInput!) {
      feed(input: $input) {
        ...FeedDetails_Feed
      }
    }
  `,
  [FeedDetails_Feed],
)

export const useFeedDetails = (input: {
  feedId: string | undefined
  organizationId: string | undefined | null
}): {
  loading: boolean
  error?: ErrorLike
  feed: ResultOf<typeof FeedDetails_Feed> | undefined
} => {
  const { feedId, organizationId } = input
  const { data, loading, error } = useQuery(GetFeedDetails, {
    variables: {
      input: {
        id: feedId ?? '',
        organizationId: organizationId ?? '',
      },
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    skip: !feedId || !organizationId,
  })

  const feed = data?.feed
    ? readFragment(FeedDetails_Feed, data.feed)
    : undefined

  return { loading, error, feed }
}
